import type { ReactNode } from "react";
import { MultipleChoiceOptions } from "@music-app/ui-components";
import type { ExerciseRendererProps } from "./types.js";

export function MultipleChoiceRenderer({
  exercise,
  pendingAnswer,
  gradingResult,
  disabled,
  onSubmit,
}: ExerciseRendererProps): ReactNode {
  const selectedId = pendingAnswer?.type === "option" ? pendingAnswer.optionId : undefined;
  const graded = gradingResult !== null;
  return (
    <MultipleChoiceOptions
      options={exercise.options}
      selectedId={selectedId}
      correctId={exercise.correctAnswerId}
      graded={graded}
      disabled={disabled}
      onSelect={(optionId) => onSubmit({ type: "option", optionId })}
    />
  );
}
